<template>
  <c-view>
    <c-page class="bg-color light-gray">
      <c-content>
        <div slot="noscroll">
          <div class="text-center failed-status">
            <img class="failed-icon" src="../../../assets/images/pay/pay-fail@2x.png"/>
            <div class="text-color orange mt-20 mb-10 failed-text"><i class="text-color orange s-icon-times-circle"></i>
              支付失败
            </div>
            <div class="text-color gray">请重新支付或选择其它支付方式</div>
          </div>
          <div class="pay-selector">
            <c-button @click.native="repayWithThirdPay">使用其他方式支付</c-button>
            <!--<c-cell-container class="item-cell-container mt-0 border-bottom">-->
            <!--<c-cell class="cell-item" title="选择支付方式" :point="false"></c-cell>-->
            <!--</c-cell-container>-->
            <!--<c-cell-container class="item-cell-container mt-0" v-for="(configItem, key) in baseEpayment" :key="key">-->
            <!--<c-cell-item :icon="configItem.icon" :title="configItem.name" :point="false" @click.native="selectPayType(configItem.type)">-->
            <!--<i class="s-icon-arrow-right" slot="foot"></i>-->
            <!--</c-cell-item>-->
            <!--</c-cell-container>-->
            <!--<c-cell-container class="item-cell-container mt-0">-->
            <!--<c-cell-item :icon="applePay" title="Apple Pay" :point="false" @click.native="selectPayType(configItem.type)">-->
            <!--<i class="s-icon-arrow-right" slot="foot"></i>-->
            <!--</c-cell-item>-->
            <!--</c-cell-container>-->
          </div>
        </div>
      </c-content>
      <div class="text-center footer-info">
        <div>支付遇到问题？请联系我们</div>
        <div class="mt-5"><a class="text-color primary tele" href="tel:4001683399">400-168-3399</a></div>
      </div>
    </c-page>
  </c-view>
</template>
<style lang="scss" scoped>
  @import './index.scss';
</style>
<script>
  import Pay from '../../../model/pay/index'

  export default {
    data () {
      return {
        applePay: require('@/assets/images/setting/sales/Apple.png'),
        baseEpayment: [{
          icon: require('@/assets/images/setting/sales/alipay.png'),
          name: '支付宝',
          payType: 101,
          type: 'alipay'
        }, {
          icon: require('@/assets/images/setting/sales/weixin.png'),
          name: '微信',
          payType: 102,
          type: 'wechatPay'
        }],
        version: '' // 当前后台为避审返回版本
      }
    },
    components: {},
    created () {
    },
    async mounted () {
      this.orderId = this.$route.query.orderId
    },
    beforeDestroy () {
    },
    methods: {
      // 使用其他方式支付
      repayWithThirdPay () {
        // 判断选择哪种支付
        let pay = new Pay()
        if (this.orderId) { // 非IOS内购失败后跳转
          pay.rePay(this.orderId)
        } else { // IOS内购失败后跳转
          console.log('payStatus', this.payStatus)
          pay.thirdPartyPay(this.payStatus.goodsId, 12)
        }
      }
    },
    computed: {
      payStatus () {
        return this.$store.getters.getPayStatus
      },
      itemObj () {
        return this.$store.getters.getOrderListItemDetail
      }
    },
    watch: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?34c390db